const BACKOFFICETRANSACTIONS_SORT_TYPES = {
  ASCENDING: 0,
  DESCENDING: 1,
};

const BACKOFFICETRANSACTIONS_SORT_KEYS = {
  PROJECT_NAME: 0,
  ACTION: 1,
  TOKEN_COUNT: 2,
  USER_PUBLIC_ADDRESS: 3,
  TOKEN_ADDRESS: 4,
  TRANSACTION_HASH: 5,
  CREATE_DATE: 6,
  TRANSACTION_STATUS: 7,
};

const sortTypes = [
  {
    name: 'Ascending',
    icon: 'BiSortUp',
  },
  {
    name: 'Descending',
    icon: 'BiSortDown',
  },
];

const sortKeys = [
  {
    name: 'Contract Name',
    key: 'project_name',
    type: 'string',
    defaultSortType: BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Action',
    key: 'action',
    type: 'string',
    defaultSortType: BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Value',
    key: 'token_count',
    type: 'number',
    defaultSortType: BACKOFFICETRANSACTIONS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'User Public Address',
    key: 'user_public_address',
    type: 'string',
    defaultSortType: BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Token Address',
    key: 'token_address',
    type: 'string',
    defaultSortType: BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Txn Hash',
    key: 'transaction_hash',
    type: 'string',
    defaultSortType: BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Txn Date',
    key: 'cdate',
    type: 'date',
    defaultSortType: BACKOFFICETRANSACTIONS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Status',
    key: 'transaction_status',
    type: 'boolean',
    defaultSortType: BACKOFFICETRANSACTIONS_SORT_TYPES.DESCENDING,
  },
];

const backofficeTransactionsQuickFilterConstants = {
  ALL: 1,
  TRUE: 2,
  FALSE: 3,
};

const backofficeTransactionsAssetFilterConstants = {
  ALL: 1,
  TOKEN: 2,
  NFT: 3,
};

export {
  BACKOFFICETRANSACTIONS_SORT_KEYS,
  BACKOFFICETRANSACTIONS_SORT_TYPES,
  sortTypes,
  sortKeys,
  backofficeTransactionsQuickFilterConstants,
  backofficeTransactionsAssetFilterConstants,
};
